import { Link } from 'react-router-dom-v5-compat';

import UnauthenticatedPage from 'dashboard/components/UnauthenticatedPage';
import FormLoginSamlSlug from 'dashboard/forms/FormLoginSamlSlug';
import { FormLoginSamlSlugData } from 'dashboard/forms/FormLoginSamlSlug/FormLoginSamlSlug';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';

interface DashboardLoginSamlSlugViewProps {
  login: (values: FormLoginSamlSlugData) => void;
}

export default ({ login }: DashboardLoginSamlSlugViewProps) => {
  return (
    <UnauthenticatedPage>
      <FormLoginSamlSlug onSubmit={login} />
      <Spacer />
      <HStack justify='space-between'>
        <Link to='/dashboard/login'>Back to Sign-in</Link>
        <Link to='/dashboard/login-saml-email'>Log in with email address</Link>
      </HStack>
    </UnauthenticatedPage>
  );
};
